module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.years) ? _c('dn-tabs', {
    attrs: {
      "id": "pg-years"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('dn-tabs-bar', {
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, _vm._l((_vm.years), function(year) {
    return _c('dn-tabs-item', {
      key: year,
      staticClass: "pg-tab-year",
      attrs: {
        "href": '#pg-years-' + year
      }
    }, [_vm._v(_vm._s(year) + "年度"), _c('span', {
      staticClass: "pg-tab-year-pos"
    }, [_vm._v("入試")])])
  })), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('dn-tabs-content', {
      key: year,
      attrs: {
        "id": 'pg-years-' + year
      }
    }, [_c('dn-pg-year', {
      attrs: {
        "year": year
      }
    })], 1)
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4586afd7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/bible/self/App.vue
// module id = 777
// module chunks = 9